import React, { useEffect, useState } from 'react';
import { HorizontalGroup, Button, Tooltip } from '@libs/uikit/Components';
import { Title } from './options/Title';
import { getTpl } from '../components/utils/tagTemplates';
import { StyledCopyButton } from './StyledCopyButton';
import { TagTextarea } from './TagTextarea';

const getCopy = () => {
    document.querySelector('.generated-flex').select();
    try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.warn(`Copying text command was ${msg}`);
    } catch (err) {
        console.warn('Oops, unable to copy', err);
    }
    window.getSelection().removeAllRanges();
};

let textFile;
const makeTextFile = (text) => {
    if (textFile !== null) {
        window.URL.revokeObjectURL(textFile);
    }
    textFile = window.URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    return textFile;
};
const saveFile = () => {
    const text = document.querySelector('.generated-flex').value;
    const anchor = document.createElement('a');
    anchor.target = '_blank';
    anchor.download = 'flex_tag.txt';
    anchor.href = makeTextFile(text);
    anchor.click();
};

export const TagGenerator = ({ activeTab, adUnits, urls, advertisementBars, headerBidding }) => {
    const [tag, setTag] = useState('');
    const isSafeFilter = activeTab === 'SAFE FRAME' ? ([_, ad]) => ad.isSafeFrame : ([_, ad]) => !ad.isSafeFrame;
    const selected = Object.entries(adUnits)
        .filter(([_, { selected }]) => selected)
        .filter(([_, { ak }]) => ak.length > 0);
    const newAdUnits = selected.filter(isSafeFilter).filter(([type]) => type !== 'passback');

    let isValid =
        newAdUnits.length > 0 &&
        newAdUnits.every(([_, { hasError }]) => !hasError) &&
        (headerBidding ? urls.every(({ hasError, url }) => !hasError && url.length > 0) : true);

    useEffect(() => {
        if (tag !== '' && !isValid) {
            setTag('');
        }
    }, [isValid]);

    const preview = () => {
        const advertsConfig = getTpl('ADVERTS')(newAdUnits, null);
        const encodedConfig = encodeURI(JSON.stringify(advertsConfig));
        window.open(`https://demopages.loopme.me/testFlex.html?config=${encodedConfig}`);
    };

    const generateTag = () => {
        const [passback] = selected.filter(([type]) => type === 'passback');
        const [, { ak, width, height }] = passback && passback.length ? passback : [, { ak: '', width: 0, height: 0 }];
        const passbackValue = passback && passback.length ? { ak, width, height } : null;
        const tag = isValid
            ? getTpl(activeTab)(newAdUnits, activeTab === 'SAFE FRAME' ? null : passbackValue, urls, !advertisementBars)
            : '';
        setTag(tag);
    };
    return (
        <>
            <Title>Flex tag</Title>
            <StyledCopyButton name="copy" onClick={getCopy} title="Copy" />
            <TagTextarea className="generated-flex" width="100%" readOnly value={tag} error={!isValid} />
            {/* {error && <Tooltip text={'One app key is required'} error position="bottom" />} */}
            <br />
            <HorizontalGroup>
                <Button onClick={generateTag} primary="true" disabled={!isValid}>
                    Generate Tag
                </Button>
                {tag !== '' && (
                    <>
                        <Button onClick={saveFile} size="M">
                            Save
                        </Button>
                        <Button onClick={preview} size="M">
                            Preview
                        </Button>
                    </>
                )}
            </HorizontalGroup>
        </>
    );
};
